import { AutogenLayoutDriverOrderInformation } from "./autogen/AutogenLayoutDriverOrderInformation";

export class DriverOrderInformation extends AutogenLayoutDriverOrderInformation {

}
